import React, { useCallback } from 'react';
import { useFocusEffect } from 'expo-router';

import { useLoyaltyOffers } from '../../useLoyaltyOffers';
import { LoyaltyOffersModal } from '../LoyaltyOffersModal';

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyOffersModalContainer = () => {
  const {
    filteredOffers,
    isShowingOffersModal,
    isOffersModalEnabled,
    hideOffersModal,
    showOffersModal,
  } = useLoyaltyOffers();

  // ─── Effects ─────────────────────────────────────────────────────────

  useFocusEffect(showOffersModal);
  useFocusEffect(useCallback(() => hideOffersModal, [hideOffersModal]));

  // ─────────────────────────────────────────────────────────────────────

  if (!isOffersModalEnabled) return null;

  return (
    <LoyaltyOffersModal
      offers={filteredOffers}
      visible={isShowingOffersModal}
      hideOffersModal={hideOffersModal}
    />
  );
};
